import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfig } from 'app/app.config';
import { AuthService } from 'app/services/auth.service';
import { StorageService } from 'app/services/database/storage.service';
import { FileService } from 'app/services/files.service';
import { PresentationHandler } from 'app/services/presentation/presentationHandler';
import { Logger } from 'app/shared/logger';
import { LoggerFactory } from 'app/shared/loggerFactory';
import { FileModel, FileModelBuilder } from 'app/views/presentations/models/file.model';
import { PresentationModel, Section } from 'app/views/presentations/models/presentation.model';
import { VideoWidget } from 'app/views/presentations/widgets/video/video.widget';

@Injectable()
export class ThumbnailHandler extends PresentationHandler {
    private logger: Logger;

    constructor(
        private auth: AuthService,
        private storageService: StorageService,
        private appConfig: AppConfig,
        private fileService: FileService,
        private http: HttpClient,
        loggerFactory: LoggerFactory
    ) {
        super();
        this.logger = loggerFactory.create('ThumbnailHandler');
    }

    public getWidgetType(): string {
        return new VideoWidget().type;
    }

    public isVideoSection(section: Section) {
        return section.type === new VideoWidget().type;
    }

    public async onSave(presentation: PresentationModel) {
        const user = await this.auth.getCurrentUser();
        for (let i = 0; i < presentation.sections.length; i++) {
            const section = presentation.sections[i];

            // Check if its a video section
            if (this.isVideoSection(section)) {
                let videoFile = section.files[0];

                // Check if its a new instance of the video
                if (!(videoFile instanceof FileModelBuilder)) continue;

                // Check if we have a thumbnail for this video
                if (section.files.length > 1) {
                    let thumbnail = section.files[1];
                    await this.fileService.deleteFile(presentation.id, i.toString(), thumbnail.id);
                }

                const metadata = await this.storageService.getMetadata(presentation.id, i.toString(), videoFile.id);
                const body = {
                    fileId: videoFile.id,
                    presentationId: presentation.id,
                    sectionId: i,
                    groupId: user.uid,
                    contentType: metadata.contentType,
                    path: metadata.fullPath,
                    bucket: metadata.bucket
                };

                const url = this.appConfig.getApiUrl('/presentation/generateThumbnail');

                try {
                    let result = await this.http.post<any>(url, body).toPromise();
                    section.files[1] = new FileModel({
                        id: result.id,
                        name: result.name,
                        size: result.size,
                        category: result.category,
                        url: result.url
                    });
                    this.logger.debug('Thumbnail generation successful.');
                } catch (e) {
                    this.logger.error('An error occured during the thumbnail generation:', e);
                }
            }
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/views/presentations/widgets/video/thumbnailHandler.ts